export const environment = {
  production: true,
  baseUrl: 'https://api.sv-doxs.net',
  assetPath: '_Resources/Static/Packages/SV.DatabaseOnline/sv-angular/assets',
  webpackPath: '_Resources/Static/Packages/SV.DatabaseOnline/sv-angular/',
};
